import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { PrimeNGSharedModule } from "./prime/prime-ng.module";
import { TableComponent } from "./components/table/table.component";
import { ModalComponent } from "./components/modal/modal.component";
import { FilterComponent } from "./components/filter/filter.component";
import { LoaderComponent } from "./components/loader/loader.component";
import { ModuleTitleComponent } from "./components/module-title/module-title.component";
import { ToastMessageComponent } from "./components/toast-message/toast-message.component";
import { TruncatePipe } from "./pipes/truncate.pipe";

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    PrimeNGSharedModule,
    TableComponent, // Imports standalone components
    ModalComponent,
    FilterComponent,
    LoaderComponent,
    ModuleTitleComponent,
    ToastMessageComponent,
    TruncatePipe,
  ],
  exports: [
    PrimeNGSharedModule,
    TableComponent, // Exports standalone components
    ModalComponent,
    FilterComponent,
    LoaderComponent,
    ModuleTitleComponent,
    ToastMessageComponent,
    TruncatePipe,
  ],
})
export class SharedModule {}
